import { render } from "./ItemComponent.vue?vue&type=template&id=364a8c13&scoped=true"
import script from "./ItemComponent.vue?vue&type=script&lang=js"
export * from "./ItemComponent.vue?vue&type=script&lang=js"

import "./ItemComponent.vue?vue&type=style&index=0&id=364a8c13&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364a8c13"]])

export default __exports__